import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Col, Form, Input, message, Modal, Row } from 'antd';

import { LockOutlined, UserOutlined } from '@ant-design/icons';

import logo from '../../assets/logo.svg';
import { api } from '../../http/API';
import { saveCompany } from '../../storage/CompanyStorage';
import { saveUser } from '../../storage/UserStorage';
import { saveZonds } from '../../storage/ZondsStorage';

const LoginPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let [showErrorModal, setShowErrorModal] = useState(false);

    const handleSubmit = async (values: any) => {
        console.log(values);

        api.LoginUser(values.username.trim(), values.password.trim())
            .then((resp: any) => {
                localStorage.setItem('token', resp['token']);

                api.GetUser()
                    .then((res) => dispatch(saveUser(res)))
                    .catch((_) => message.error('Не удалось загрузить пользователя, повторите попытку позже'));

                api.GetCompany()
                    .then((res) => dispatch(saveCompany(res)))
                    .catch((_) => message.error('Не удалось загрузить данные о компании, повторите попытку позже'));

                api.GetZonds()
                    .then((res) => dispatch(saveZonds(res)))
                    .catch((_) => message.error('Не удалось загрузить метеоустройства, повторите попытку позже'));

                window.location.href = '/';
                message.success('Вход выполнен успешно');

                if (!localStorage.getItem('agreement')) {
                    localStorage.setItem('agreement', 'no');
                    window.location.reload();
                }
            })
            .catch((error) => {
                if (!error.response) {
                    message.error('Сервис временно недоступен');
                } else {
                    message.error('Неверные логин или пароль');
                    setShowErrorModal(true);
                }
            });
    };

    return (
        <>
            <Row justify="center">
                <Col>
                    <div style={{ width: 220, margin: '50px auto', textAlign: 'center' }}>
                        <img style={{ float: 'left', marginRight: 12 }} src={logo} alt={'logo'} height={80} />
                        <h1 className="text" style={{ margin: 0 }}>
                            Агропогода
                        </h1>
                        <h3 className="text" style={{ margin: 0 }}>
                            Личный кабинет
                        </h3>
                    </div>
                    <div style={{ clear: 'left' }} />

                    <Form onFinish={handleSubmit} autoComplete="off">
                        <Form.Item name="username" rules={[{ required: true, message: 'Введите логин' }]}>
                            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Логин" />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: 0 }}
                            name="password"
                            rules={[{ required: true, message: 'Введите пароль' }]}
                        >
                            <Input.Password
                                prefix={<LockOutlined className="site-form-item-icon" />}
                                type="password"
                                placeholder="Пароль"
                            />
                        </Form.Item>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 16,
                                width: '100%',
                                margin: '4px 0 12px',
                            }}
                        >
                            <Button type="link" style={{ padding: 0 }} onClick={() => navigate('/register')}>
                                Зарегистрироваться
                            </Button>
                            <Button type="link" style={{ padding: 0 }} onClick={() => navigate('/forgot-password')}>
                                Забыли пароль?
                            </Button>
                        </div>

                        <Form.Item style={{ margin: 0 }} wrapperCol={{ offset: 8, span: 16 }}>
                            <Button size="large" type="primary" htmlType="submit">
                                Войти
                            </Button>
                        </Form.Item>
                    </Form>
                </Col>
                <Modal
                    title="Не удалось войти"
                    onCancel={() => setShowErrorModal(false)}
                    open={showErrorModal}
                    footer={[
                        <Button key="cancel" onClick={() => setShowErrorModal(false)}>
                            Отмена
                        </Button>,
                        <Button
                            key="forgot"
                            type="primary"
                            onClick={() => {
                                setShowErrorModal(false);
                                navigate('/forgot-password');
                            }}
                        >
                            Восстановить пароль
                        </Button>,
                    ]}
                >
                    <p>
                        <strong>Не выходит войти со своими данными?</strong>
                    </p>
                    <p>
                        Возможно, вы забыли пароль или ошиблись при вводе. Нажмите
                        «Восстановить пароль» — мы отправим код на ваш email.
                    </p>
                </Modal>
            </Row>
        </>
    );
};

export default LoginPage;
